import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import { appStateMutate } from "stores/modules/app.state/operations";
import {
  getRoomSavedataByOrder,
  getRoomSavedataIdByOrder,
} from "stores/modules/entities.room.savedatas/selectors";
import styled from "styled-components";
import SavedataItem from "./SavedataItem";

const SavedataList = () => {
  return (
    <Savedatas>
      <SavedataContainer slot={0} />
      <SavedataContainer slot={1} />
      <SavedataContainer slot={2} />
    </Savedatas>
  );
};

type SavedataContainerProps = {
  slot: number;
};

const SavedataContainer = ({ slot }: SavedataContainerProps) => {
  const savedataId = useAppSelector((state) =>
    getRoomSavedataIdByOrder(state, slot)
  );
  const savedata = useAppSelector((state) =>
    getRoomSavedataByOrder(state, slot)
  );
  const dispatch = useAppDispatch();
  const handleClick = useCallback(() => {
    if (savedataId) {
      dispatch(
        appStateMutate((state) => {
          state.openLoadConfirm = true;
          state.openLoadConfirmId = savedataId;
        })
      );
    }
  }, [savedataId, dispatch]);

  const disabled = savedataId == null;
  const name = savedata == null ? "NODATA" : savedata.name;

  return (
    <SavedataItem
      thumbnail={savedata?.thumbnail}
      name={name}
      updatedAt={savedata?.updatedAt}
      disabled={disabled}
      onClick={handleClick}
    />
  );
};

const Savedatas = styled.div`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar: {
    display: none;
  }
`;

export default memo(SavedataList);
